// Social media platform sizing presets
// Each preset defines a target output dimension. Aspect ratio is derived.

export const PLATFORMS = [
  {
    id: "instagram",
    name: "Instagram",
    color: "#E4405F",
    presets: [
      { id: "profile", label: "Profile Photo", w: 320, h: 320, ratio: "1:1" },
      { id: "post-square", label: "Post (Square)", w: 1080, h: 1080, ratio: "1:1" },
      { id: "post-portrait", label: "Post (Portrait)", w: 1080, h: 1350, ratio: "4:5" },
      { id: "post-landscape", label: "Post (Landscape)", w: 1080, h: 566, ratio: "1.91:1" },
      { id: "story", label: "Story", w: 1080, h: 1920, ratio: "9:16" },
      { id: "reel", label: "Reel", w: 1080, h: 1920, ratio: "9:16" },
      { id: "reel-cover", label: "Reel Cover", w: 1080, h: 1920, ratio: "9:16" },
    ],
  },
  {
    id: "facebook",
    name: "Facebook",
    color: "#1877F2",
    presets: [
      { id: "profile", label: "Profile Photo", w: 720, h: 720, ratio: "1:1" },
      { id: "post-square", label: "Post (Square)", w: 1200, h: 1200, ratio: "1:1" },
      { id: "story", label: "Story", w: 1080, h: 1920, ratio: "9:16" },
      { id: "reel", label: "Reel", w: 1080, h: 1920, ratio: "9:16" },
      { id: "group-cover", label: "Group Cover", w: 1640, h: 922, ratio: "16:9" },
      { id: "event-cover", label: "Event Cover", w: 1920, h: 1005, ratio: "1.92:1" },
    ],
  },
  {
    id: "youtube",
    name: "YouTube",
    color: "#FF0000",
    presets: [
      { id: "profile", label: "Profile Photo", w: 800, h: 800, ratio: "1:1" },
      { id: "thumbnail", label: "Thumbnail", w: 1280, h: 720, ratio: "16:9" },
      { id: "banner", label: "Banner", w: 2560, h: 1440, ratio: "16:9" },
    ],
  },
  {
    id: "x",
    name: "X (Twitter)",
    color: "#FFFFFF",
    presets: [
      { id: "profile", label: "Profile Picture", w: 400, h: 400, ratio: "1:1" },
      { id: "header", label: "Header", w: 1500, h: 500, ratio: "3:1" },
      { id: "post", label: "Post Image", w: 1200, h: 675, ratio: "16:9" },
    ],
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    color: "#0A66C2",
    presets: [
      { id: "profile", label: "Profile Photo", w: 400, h: 400, ratio: "1:1" },
      { id: "background", label: "Background Photo", w: 1584, h: 396, ratio: "4:1" },
      { id: "company-logo", label: "Company Logo", w: 400, h: 400, ratio: "1:1" },
      { id: "cover", label: "Cover Photo", w: 1128, h: 191, ratio: "5.91:1" },
    ],
  },
  {
    id: "pinterest",
    name: "Pinterest",
    color: "#E60023",
    presets: [
      { id: "square", label: "Square Pin", w: 1000, h: 1000, ratio: "1:1" },
      { id: "standard", label: "Standard Pin", w: 1000, h: 1500, ratio: "2:3" },
      { id: "vertical", label: "Vertical Pin", w: 1080, h: 1920, ratio: "9:16" },
    ],
  },
  {
    id: "tiktok",
    name: "TikTok",
    color: "#FE2C55",
    presets: [
      { id: "profile", label: "Profile Picture", w: 200, h: 200, ratio: "1:1" },
      { id: "video-cover", label: "Video Cover", w: 1080, h: 1920, ratio: "9:16" },
    ],
  },
  {
    id: "tumblr",
    name: "Tumblr",
    color: "#36465D",
    presets: [
      { id: "profile", label: "Profile Picture", w: 128, h: 128, ratio: "1:1" },
      { id: "header", label: "Header", w: 3000, h: 1055, ratio: "16:9" },
    ],
  },
  {
    id: "snapchat",
    name: "Snapchat",
    color: "#FFFC00",
    presets: [
      { id: "share", label: "Image Share", w: 1080, h: 1920, ratio: "9:16" },
    ],
  },
  {
    id: "vinted",
    name: "Vinted",
    color: "#09B1BA",
    presets: [
      { id: "profile", label: "Profile Picture", w: 400, h: 400, ratio: "1:1" },
      { id: "item", label: "Item Photo", w: 800, h: 1200, ratio: "2:3" },
    ],
  },
  {
    id: "email",
    name: "Email",
    color: "#34D399",
    presets: [
      { id: "blog-featured", label: "Blog Featured", w: 1500, h: 500, ratio: "3:1" },
      { id: "blog-image", label: "Blog Image", w: 800, h: 800, ratio: "1:1" },
      { id: "newsletter", label: "Newsletter", w: 1600, h: 800, ratio: "2:1" },
    ],
  },
];

export const FIT_METHODS = [
  { id: "stretch", label: "Stretch" },
  { id: "auto-crop", label: "Auto Crop" },
  { id: "fit", label: "Fit (with background)" },
];

export const FIT_BG = [
  { id: "white", label: "White", color: "#FFFFFF" },
  { id: "black", label: "Black", color: "#000000" },
  { id: "blur", label: "Blur" },
];

export const OUTPUT_FORMATS = [
  { id: "jpeg", label: "JPEG", mime: "image/jpeg", ext: "jpg" },
  { id: "png", label: "PNG", mime: "image/png", ext: "png" },
  { id: "webp", label: "WebP", mime: "image/webp", ext: "webp" },
];

export const MAX_FILES = 10;

export function getPlatform(id) {
  return PLATFORMS.find((p) => p.id === id) || PLATFORMS[0];
}

export function getPreset(platformId, presetId) {
  const platform = getPlatform(platformId);
  return platform.presets.find((p) => p.id === presetId) || platform.presets[0];
}
